import Vue from 'vue'
import Router from 'vue-router'
import Welcome from './views/Welcome.vue'
import Home from './views/Home.vue'
import Wishlist from './views/Wishlist.vue'
import Guests from './views/Guests.vue'
import Guest from './views/Guest.vue'
import Chat from './views/Chat.vue'
import Gallery from './views/Gallery.vue'
import Wish from './views/Wish.vue'
import Party from './views/Party.vue'
import Kid from './views/Kid.vue'
import User from './views/User.vue'
import WishSelected from './views/WishSelected.vue'
import GuestSelected from './views/GuestSelected.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/kid',
      name: 'kid',
      component: Kid,
    },
    {
      path: '/user',
      name: 'user',
      component: User,
    },
    {
      path: '/wishlist',
      name: 'wishlist',
      component: Wishlist,
    },
    {
      path: '/wishlist/wish',
      name: 'wish',
      component: Wish
    },
    {
      path: '/wishlist/wish/selected',
      name: 'wishselected',
      component: WishSelected
    },
    {
      path: '/party',
      name: 'party',
      component: Party

    },
    {
      path: '/guests',
      name: 'guests',
      component: Guests
    },
    {
      path: '/guests/guest',
      name: 'guest',
      component: Guest
    },
    {
      path: '/guests/guest/thatsus',
      name: 'guestselected',
      component: GuestSelected,
      props: true
   },
    {
      path: '/chat',
      name: 'chat',
      component: Chat
    },
    {
      path: '/gallery',
      name: 'gallery',
      component: Gallery
    },
    {
      path: '/',
      name: 'home',
      component: Home,
    },    
    
    {
      path: '/:id',
      name: 'welcome',
      component: Welcome,
      props: true
    },    
  ]
})
